import { FileIconType } from '@uifabric/file-type-icons/lib/index';
import { Facet } from '../models/Facet';

/**
 * Facet which indicates the icon type for a file item.
*/
export const fileIconTypeFacet: Facet<FileIconType> = new Facet('fileIconType');

/**
 * Facet which indicates that an item is a oneNote.
 */
export const oneNoteFacet: Facet<{}> = new Facet('oneNote');
